import api from './api';

export const orderService = {
    getAllOrders: (params) => api.get('/orders', { params }),

    getOrderById: (id) => api.get(`/orders/${id}`),

    createOrder: (orderData) => api.post('/orders', orderData),

    updateOrder: (id, orderData) => api.put(`/orders/${id}`, orderData),

    deleteOrder: (id) => api.delete(`/orders/${id}`),
    getOrderStats: (params) => api.get('/orders/stats', { params }),
    getOrderAlerts: () => api.get('/orders/alerts'),
};
